var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "currentColor",
  fillRule: "evenodd",
  stroke: "currentColor"
}, /*#__PURE__*/React.createElement("path", {
  d: "M16 .5c.392 0 .75.153 1.018.402.266.247.444.588.477.97h0L17.5 8.5h-1v-7h-15V17a1.5 1.5 0 001.357 1.493h0L6.5 18.5V19.5H2a1.498 1.498 0 01-1.495-1.37h0L.51 2c0-.394.15-.754.398-1.023.243-.264.58-.439.962-.471h0z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14 11.5a4.5 4.5 0 110 9 4.5 4.5 0 010-9zm0 1a1.44 1.44 0 00-1.03.425c-.251.25-.43.607-.47 1.05h0v.525H12l-.147.007c-.34.033-.646.18-.884.418-.245.246-.421.592-.469 1.075 0 .397.153.758.425 1.03.25.251.607.43 1.05.47h0l.525.5.007.147c.033.34.18.646.418.884.246.245.592.421 1.075.469a1.44 1.44 0 001.03-.425c.251-.25.43-.607.47-1.05h0l.5-.525.147-.007c.34-.033.646-.18.884-.418.245-.246.421-.592.469-1.075a1.44 1.44 0 00-.425-1.03 1.677 1.677 0 00-1.05-.47h0L15.5 14l-.007-.147a1.436 1.436 0 00-.418-.884c-.246-.245-.592-.421-1.075-.469z"
}));

var SvgClaim = function SvgClaim(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 19 21",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgClaim, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/claim.e936d4cc.svg";
export { ForwardRef as ReactComponent };